import { compose, branch, renderNothing } from 'recompose'
import * as R from 'ramda'

import { shouldRenderBenefit } from './utils'

const enhance = compose(
  branch(
    R.propSatisfies(R.complement(shouldRenderBenefit), 'benefit'),
    renderNothing,
  ),
)

export default enhance
